module.exports = __webpack_public_path__ + "img/gb9123_30_d.prt.d08424a2.jpg";